import React, { useState, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { REGISTRATION_URL, BUSINESS_LIST_URL } from "@/lib/constants";
import RegistrationModal from "@/components/RegistrationModal";

// Lazy load page components
const HomePage = lazy(() => import("@/components/HomePage"));
const RegistrationPage = lazy(() => import("@/components/RegistrationPage"));
const BusinessListPage = lazy(() => import("@/components/BusinessListPage"));

// Loading fallback for the whole page
const PageLoader = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="w-16 h-16 border-4 border-gold/20 border-t-gold rounded-full animate-spin" />
  </div>
);

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route 
              path={REGISTRATION_URL} 
              element={<RegistrationPage onOpenModal={() => setIsModalOpen(true)} />} 
            />
            <Route 
              path={BUSINESS_LIST_URL} 
              element={<BusinessListPage />} 
            />
          </Routes>
        </Suspense>
        <RegistrationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </BrowserRouter>
    </div>
  );
}

export default App;
